import { Capacitor } from '@capacitor/core';

export function getFunctionBaseUrl(): string {
  if (Capacitor.getPlatform() !== 'web') {
    // Capacitor build (iOS or Android)
    return 'https://playletterswap.com';
  }

  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    // Local dev (`npm run dev`)
    return 'http://localhost:8888';
  }

  return '';
}
